export enum TwoFactorMethodEnum {
    Email = 'EMAL',
    SMS = 'SMS',
    Unknown = 'Unknown',
}
